export default {
  passenger: "Passenger",
  AddPassenger: "AddPassenger",
  editPassenger: "EditPassenger",
  passengerProfile: "PassengerProfile",
};
